module.exports = __webpack_public_path__ + "static/media/nico-robin-win.13d5c6a2.png";